import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import BrowserProofApp, { shouldRenderBrowserProof } from './browserProof/BrowserProofApp';
import { registerServiceWorker } from './utils/swRegistration';
import { initAnalytics } from './utils/analytics';
import './i18n';

function findMountContainer() {
  const candidateIds = ['root', 'app', 'main'];
  for (const id of candidateIds) {
    const el = document.getElementById(id);
    if (el) return el;
  }
  return null;
}

function mountReact(container) {
  const root = ReactDOM.createRoot(container);
  const RootComponent = shouldRenderBrowserProof() ? BrowserProofApp : App;
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <RootComponent />
      </AuthProvider>
    </React.StrictMode>
  );
}

function safeRenderApp() {
  initAnalytics();
  let container = findMountContainer();
  if (!container) {
    let attempts = 0;
    const maxAttempts = 20; // ~1s con intervallo di 50ms
    const interval = setInterval(() => {
      container = findMountContainer();
      attempts += 1;
      if (container) {
        clearInterval(interval);
        mountReact(container);
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        const fallback = document.createElement('div');
        fallback.id = 'root';
        document.body.appendChild(fallback);
        mountReact(fallback);
      }
    }, 50);
    return;
  }
  mountReact(container);
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', safeRenderApp, { once: true });
} else {
  safeRenderApp();
}

// Register Service Worker for PWA functionality
if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
} else {
  // In development, register SW only if explicitly enabled
  if (process.env.REACT_APP_ENABLE_SW === 'true') {
    registerServiceWorker();
  }
}
